export enum PromotionalProcessTabs {
  MAIN_DATA_TAB = 'mainData',
  TASKS_TAB = 'tasksTab',
}

export interface PromotionalProcessList {
  id: number;
  code: string;
  name: string;
  planningDays: number;
  minimumCoverage: number;
  inUse: boolean;
  taskQuantity: number;
  customFields: any[];
}

export interface PromotionalProcessItem {
  id: number;
  code: string;
  name: string;
  inUse: boolean;
  minimumCoverage: number;
  tasks: PromotionalProcessTasksFromBe[];
}

export interface PromotionalProcessTasks {
  id: number;
  name: string;
  fromDate: string;
  taskOwner: TaskAssignees;
  consultants: TaskConsultantsAssignees;
  durationInDays: number;
  requiresCompletion: boolean;
  actionableId: number;
}

export interface SelectableItem {
  id: string;
  name: string;
}

export type TaskFieldValue = TaskAssignees | SelectableItem[] | null;

export interface TaskAssignees {
  roles: SelectableItem[];
  users: SelectableItem[];
}

interface TaskConsultantsAssignees extends TaskAssignees {
  consultors: { name: string; id: string | number }[];
}

export interface PromotionalProcessFormModel {
  mainData: PromotionalProcessMainData;
  tasksTab: {
    tasks: PromotionalProcessTasksFromBe[];
  };
}

export interface PromotionalProcessMainData {
  id: number;
  name: string;
  code: string;
  inUse: boolean;
  minimumCoverage: number;
}

export enum TaskStartingDayPosition {
  before = 'before',
  after = 'after',
}

export interface PromotionalProcessTasksFromBe {
  id: number;
  internalId?: string;
  name: string;
  startingDay: number;
  startingDayPosition?: TaskStartingDayPosition;
  taskOwners: TaskAssignees;
  consultants: TaskAssignees;
  durationInDays: number;
  requiresCompletion: boolean;
  actionables: SelectableItem[];
}
